export const FOLDER_TRASH = 'trash';
